<template>
  <div class="wrapper-content w-100 border-top border-bbva-mod p-0">
    <!--Bienestar-->
    <section class="wrapper-pleno col-md-12 bg-bbva-mod px-3">
      <div class="wrapper-steps">

        <button v-show="videos.length >= 4" @click="scrollLeft()" class="btn scroll-video-btn left-arrow arrow-none">
          <span class="arrow-left"></span>
        </button>
        <button v-show="videos.length >= 4" @click="scrollRight()" class="btn scroll-video-btn right-arrow arrow-none">
          <span class="arrow-right"></span>
        </button>
        <button @click="scrollLeftMB()" class="btn scroll-video-btn left-arrow arrow-block">
          <span class="arrow-left"></span>
        </button>
        <button @click="scrollRightMB()" class="btn scroll-video-btn right-arrow arrow-block">
          <span class="arrow-right"></span>
        </button>

        <div class="px-1">
          <div class="flex-column content-steps h-100 m-0 px-4">
            <div class="col-bbva wrapper-col-rayos">
              <div class="logo-section h-100 align-items-start pt-sm-2 mx-0">
                <div class="px-0 h-100">
                  <div
                    class="d-flex flex-row align-items-center justify-content-between h-100 pl-0 pb-3 pr-2 flex-mod-bbva">

                    <img src="/images/bbva/bbva_aprendamos.png" alt="Logo de BBVA - Aprendemos juntos 2030"
                      class="img-bbva img-fluid">
                    <div class="d-flex flex-row align-items-center align-items-sm-center mx-3 flex-mod-bbva">
                      <p class="p-bbva text-white font-PB text-end mb-0">Aprendemos <br class="d-none-mod">juntos</p>
                      <div class="vertical-line d-none-mod"></div>
                      <p class="p-sub-bbva text-white p-sm font-PM text-center text-sm-start px-0 mb-0 mt-1">
                        Nuestro propósito es poner al alcance de <br class="br-mod-bbva"> todos las
                        oportunidades de esta nueva era.
                      </p>
                    </div>
                    <a href="https://aprendemosjuntos.bbva.com/?cid=dislnc00008437-aprendemos_juntos_la_nacion_display_nov-bri-cinturonvoces-brand-"
                      class="BBVAbtn d-none-mod px-2" target="_blank">
                      <p class="BBVAbtnP font-A12 text-uppercase">Ver más videos</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="overflow-hidden pl-0 pr-0 d-flex">

              <div class="col wrapper-col-bbva-videos pr-4 pl-0 custom-scrollbar" ref="scrollContent">
                <div class="align-items-center col-bbva-videos col-md d-flex h-100 mx-0 pl-0 pr-5">
                  <!-- IMPLEMENTACION ANTERIOR CON REPRODUCCION DENTRO DEL ANEXO -->
                  <div class="d-flex">
                    <div class="bbva-video me-2 position-relative d-flex justify-content-center overflow-hidden"
                      v-for="(video, index) in videos" :key="index">
                      <a :href="video.url" target="_blank" :title="video.titulo" class="btn btn-container">
                        <img :src="video.thumbnail" :alt="video.alt" class="video-cover">
                      </a>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="video-read-more">
        <a href="https://aprendemosjuntos.bbva.com/?cid=dislnc00008437-aprendemos_juntos_la_nacion_display_nov-bri-cinturonvoces-brand-"
          class="BBVAbtn d-block-mod d-sm-none mt-4 mb-3 mx-auto" target="_blank">
          <p class="BBVAbtnP btn-mb mb-0 font-A12 text-uppercase">Ver más videos</p>
        </a>
      </div>

    </section>
  </div>
</template>


<script>

export default {
  name: 'anexobbvavideosnew',
  props: {
    videos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      previouslyPlayedVideoIndex: null,
      window: {
        width: 0
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    console.log(this.videos);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    playVideo(index) {
      if (this.previouslyPlayedVideoIndex !== null) {
        this.$refs.youtube[this.previouslyPlayedVideoIndex].player.stopVideo();
        this.$refs.thumbnail[this.previouslyPlayedVideoIndex].classList.remove("d-none");
      }
      this.$refs.youtube[index].player.playVideo()
      this.previouslyPlayedVideoIndex = index;
      this.$refs.thumbnail[index].classList.add("d-none");
    },
    scrollLeft() {
      this.$refs.scrollContent.scrollLeft -= 280
    },
    scrollRight() {
      this.$refs.scrollContent.scrollLeft += 280
    },
    scrollLeftMB() {
      this.$refs.scrollContent.scrollLeft -= 335
    },
    scrollRightMB() {
      this.$refs.scrollContent.scrollLeft += 335
    }
  },
}

</script>
